import { render, staticRenderFns } from "./BizBusinessinfoReport.vue?vue&type=template&id=54b5bedd&"
import script from "./BizBusinessinfoReport.vue?vue&type=script&lang=js&"
export * from "./BizBusinessinfoReport.vue?vue&type=script&lang=js&"
import style0 from "./BizBusinessinfoReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports